<script>
    import { blur } from 'svelte/transition';
    import OPTS from "../options";

    export let path;
    export let title = 'ND';
    export let children = [];
    let expanded = path !== OPTS.active_path && OPTS.active_path.startsWith(path);

    $: node_class = expanded ? "list-group-item tree-item-expanded" : "list-group-item d-flex align-items-center";

    async function toggle() {
        expanded = !expanded;
    }

    function openLink() {
        if (OPTS.mode === 'esito') {
            window.updateSearch(path, title);
        } else if (OPTS.mode === 'home') {
            window.newSearch(path, title);
        }
    }
</script>

<li class={node_class} class:tree-item-active={path === OPTS.active_path}>
    {#if children.length}
        <a href="#" on:click|preventDefault={toggle} class="fas {expanded ? 'fa-folder-minus' : 'fa-folder-plus'} tree-item-icon" title="{expanded ? OPTS.label_close : OPTS.label_open}" aria-hidden="true"></a>
    {:else}
        <span class="fas fa-file tree-item-icon" title="" aria-hidden="true"></span>
    {/if}
    <a href="#" on:click|preventDefault={openLink}>{path.indexOf('/') !== -1 ? title : title.toUpperCase()}</a>

    {#if expanded}
        <div class="panel panel-default" in:blur>
            <div class="panel-body bg-secondary tree-child-container">
                <ul class="list-group list-group-flush">
                    {#each children as child (child.path)}
                        <svelte:self {...child}/>
                    {/each}
                </ul>
            </div>
        </div>
    {/if}
</li>

<style>
    .panel {
        box-shadow: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        background-color: transparent;
        margin-bottom: 0 !important;
    }
    .panel-body {
        margin-bottom: 0 !important;
    }
    .panel-default {
        border-color: transparent;
    }

    .tree-tag-container {
       display: inline;
    }

    .tree-item-icon {
        margin-right: 10px;
    }

    .tree-item-expanded > .tree-tag-container {
        float: right;
        margin-right: 1.25rem;
    }

    .list-group-item > a {
        text-decoration: none;
        color: black;
    }

    .tree-child-container {
        border-left: 0 !important;
        border-right: none !important;
        border-top: none !important;
        border-bottom: none !important;
    }

    .tree-tag-container .badge {
        background-color: #8b022e;
    }
</style>